// extracted by mini-css-extract-plugin
module.exports = {"root":"i1VMYxne"};